<script>
// Encabezado de página del design system APPMISIONATE.
//
// Vocabulario propio (.app_page_header) separado del heredado de clases en vivo
// (.stream_page_header), que sigue vivo en el area de estudiante. La migracion
// del prefijo `stream_` es la fase L5 de docs/estrategia-titulos-admin.md.
export default {
  name: 'PageHeaderView',
  props: {
    // Clase CSS completa del icono, p. ej. 'fas fa-broadcast-tower'.
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <header class="app_page_header">
    <div class="app_page_header_main">
      <span class="app_page_header_icon">
        <i :class="icon" />
      </span>
      <div class="app_page_header_text">
        <h2 class="app_page_header_title">
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="app_page_header_subtitle"
        >
          {{ subtitle }}
        </p>
      </div>
    </div>
    <div
      v-if="$slots.right"
      class="app_page_header_actions"
    >
      <slot name="right" />
    </div>
  </header>
</template>
